<template>
	<div id="ContextMenu">
		<span @contextmenu="(defaultButtonValue == 'right') ? openMenu($event) : disabledOption($event)">
			<button ref="btnEjecute" @click="ejecute"></button>
			<span :title="title" :class="_class">{{ text }}</span>
			<ul class="context-menu" ref="contextMenu" tabindex="-1" v-show="viewMenu" @blur="blurMenu">
				<li v-if="emptyList && listLocal.length == 0" class="disabled">No está configurado el menú</li>
				<li v-for="(item, index) in listLocal" :key="index" class="enabled" @click="selectItem(index)" v-if="defaultSelectedValue != item.id">
					{{ item.text }}
					<span class="float-right text-right" style="width:30px">
						<i class="fas fa-check" v-if="item.selected && markSelectionValue"></i>
					</span>
				</li>
				<li v-if="listLocal.length > 0 && multiSelectValue" class="enabled" @click="selectAllItem()">
					Todo
					<span class="float-right text-right" style="width:30px">
						<i class="fas fa-check" v-if="selectedAll"></i>
					</span>					
				</li>
			</ul>
		</span>
	</div>
</template>

<script>
	export default {
		name: 'ContextMenu',
		props: ['_class', 'text', 'title', 'list', 'multiSelect', 'markSelection', 'defaultSelected', 'saveSelection', 'localStorage', 'defaultButton'],
		data () {
			return {
				listLocal: [],
				mousePosition: {
					top: '0px',
					left: '0px'
				},
				viewMenu: false,
				selectedAll: false
			}
		},
		computed: {
			defaultSelectedValue() {		
				if(this.defaultSelected == undefined)
					return -1
				return this.defaultSelected
			},
			defaultButtonValue() {
				let _default = 'right'
				if(this.defaultButton != undefined)
					_default = this.defaultButton
				return _default
			},
			emptyList() {
				if(this.list == undefined || this.list.length == 0)
					return true
				return false
			},
			idParet() {
				return this.$parent.$el.id
			},
			localStorageValue() {
				let id = (this.localStorage == undefined || this.localStorage == null) ? '' : '-' + this.localStorage
				return this.idParet + id
			},
			multiSelectValue() {
				if(this.multiSelect == true)
					return true
				return false
			},
			markSelectionValue() {
				if(this.markSelection == true)
					return true
				return false
			},
			saveSelectionValue() {
				if(this.saveSelection == true)
					return true
				return false
			},
		},
		methods: {
			disabledOption(e) {
				console.log(e)
			},
			ejecute() {
				this.list.forEach((el) => {
					this.listLocal.push({id: el.id, text: el.text, selected: false})
				})
				if(this.multiSelect == true) {
					this.listLocal.forEach((item) => {
						item.selected = false
					})
					let itemsSelected = (localStorage.getItem(this.localStorageValue) != null && localStorage.getItem(this.localStorageValue) != undefined && localStorage.getItem(this.localStorageValue) != 'null' && localStorage.getItem(this.localStorageValue) != 'undefined') ? JSON.parse(localStorage.getItem(this.localStorageValue)) : []
					itemsSelected.forEach((e) => {
						let index = this.listLocal.map(el => (el.id)).indexOf(e)
						if(index > -1) {
							this.listLocal[index].selected = true
						}
					})
					this.selectedAll = (itemsSelected.length == this.listLocal.length)
					this.$emit('actionBlur', this.listLocal)
				} else {
					let itemsSelected = (localStorage.getItem(this.localStorageValue) != null && localStorage.getItem(this.localStorageValue) != undefined) ? localStorage.getItem(this.localStorageValue) : this.defaultSelectedValue
					if(this.saveSelectionValue) {
						localStorage.setItem(this.localStorageValue, itemsSelected)
						let index = this.listLocal.map(el => (el.id)).indexOf(itemsSelected)
						if(index > -1) {
							this.listLocal[index].selected = true
							this.$emit('actionSelectItem', this.listLocal[index])
						}
					}
				}
			},
			blurMenu() {
				this.closeMenu()
				this.$emit('actionBlur', this.listLocal)
			},
			openMenu(e) {
				this.viewMenu = true
				this.$nextTick(function() {
					this.$refs.contextMenu.focus();
					this.setMenu(e.y - 94, e.x - 136)
				});
				e.preventDefault();
			},
			closeMenu() {
				this.viewMenu = false
			},
			setMenu(top, left, offsetHeight, offsetWidth) {
				let largestHeight = window.innerHeight - this.$refs.contextMenu.offsetHeight - 25;
				let largestWidth = window.innerWidth - this.$refs.contextMenu.offsetHeight - 25;
				if (top > largestHeight) top = largestHeight;
				if (left > largestWidth) left = largestWidth;
				this.mousePosition.top = top + 'px';
				this.mousePosition.left = left + 'px';
			},
			selectAllItem() {
				let itemsSelected = []
				if(this.selectedAll) {
					this.listLocal.forEach((item) => {
						item.selected = false
					})
					this.selectedAll = false				
				} else {
					this.listLocal.forEach((item) => {
						item.selected = true
						itemsSelected.push(item.id)
					})
					this.selectedAll = true
				}
				localStorage.setItem(this.localStorageValue, JSON.stringify(itemsSelected))
			},
			selectItem(index) {
				if(!this.multiSelectValue) {
					this.listLocal.forEach((item) => {
						item.selected = false
					})
					this.listLocal[index].selected = true
					if(this.saveSelectionValue == true) {
						localStorage.setItem(this.localStorageValue, this.listLocal[index].id)
					}		
					this.$emit('actionSelectItem', this.listLocal[index])
					this.closeMenu()
				} else {
					this.listLocal[index].selected = !this.listLocal[index].selected
					let itemsSelected = (localStorage.getItem(this.localStorageValue) != null && localStorage.getItem(this.localStorageValue) != undefined && localStorage.getItem(this.localStorageValue) != 'null' && localStorage.getItem(this.localStorageValue) != 'undefined') ? JSON.parse(localStorage.getItem(this.localStorageValue)) : []
					let i = itemsSelected.map(el => (el)).indexOf(this.listLocal[index].id)
					if(this.listLocal[index].selected == true && i == -1) {
						itemsSelected.push(this.listLocal[index].id)
					} else if(this.listLocal[index].selected == false && i > -1) {
						let deleteItemsSelected = itemsSelected.splice(i,1)
					}
					localStorage.setItem(this.localStorageValue, JSON.stringify(itemsSelected))
					this.selectedAll = (itemsSelected.length == this.listLocal.length)
					this.$emit('actionSelectItem', this.listLocal)
				}
			}
		},
		mounted () {
		}
	}
</script>

<style scoped lang="scss">
	.context-menu {
		background: #FDFDFD;
		border: 1px solid #DDDDDD;
		box-shadow: 0 2px 5px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);
		display: block;
		list-style: none;
		margin: 0;
		padding: 3px 0px;
		position: absolute;
		z-index: 999999;
	}

	.context-menu li {
		font-size: 12px;
		text-align: left;
		font-family: Arial, Helvetica, sans-serif;
		font-weight: normal;
		margin: 0;
		padding: 3px 25px 3px 30px;
	}

	.context-menu li.enabled {
		cursor: context-menu;
	}

	.context-menu li.disabled {
		color: #aaa;
		cursor: no-drop;
	}

	.context-menu li:last-child {
		border-bottom: none;
	}

	.context-menu li.enabled:hover {
		background: #dfdfdf;
	}
</style>
